import { render, staticRenderFns } from "./AssetDataButton.vue?vue&type=template&id=3fa2ff7c&scoped=true&"
import script from "./AssetDataButton.vue?vue&type=script&lang=js&"
export * from "./AssetDataButton.vue?vue&type=script&lang=js&"
import style0 from "./AssetDataButton.vue?vue&type=style&index=0&id=3fa2ff7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2ff7c",
  null
  
)

export default component.exports